function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { StyledEmailInput } from "./email-input-component.scss";
import { EMAIL_PATTERN } from "constants/input-validations-patterns";
class EmailInput extends PureComponent {
    componentDidMount() {
        const { placeholderFocusColor } = this.props;
        if (placeholderFocusColor) {
            this._input.style.setProperty("--placholder-focus-color", placeholderFocusColor);
        }
    }
    componentDidUpdate() {
        const { focusOnUpdate } = this.props;
        focusOnUpdate && setTimeout(this.focus, 0);
    }
    focus() {
        this._input.focus();
    }
    isValid() {
        //Dont use input pattern, it doesnt work in safari
        return this._input.checkValidity() && EMAIL_PATTERN.test(this._input.value);
    }
    render() {
        const _this_props = this.props, { focusOnUpdate, forceHorizontal, placeholderFocusColor } = _this_props, otherProps = _object_without_properties(_this_props, [
            "focusOnUpdate",
            "forceHorizontal",
            "placeholderFocusColor"
        ]);
        return /*#__PURE__*/ _jsx(StyledEmailInput, _object_spread_props(_object_spread({}, otherProps), {
            ref: (el)=>this._input = el
        }));
    }
    constructor(props){
        super(props);
        this._input = null;
        this.focus = this.focus.bind(this);
    }
}
export { EmailInput as default };
EmailInput.defaultProps = {
    value: "",
    autoComplete: "off",
    autoCapitalize: "off",
    spellCheck: "false",
    className: "email",
    type: "email",
    placeholder: "",
    name: "email",
    required: true,
    focusOnUpdate: false
};
